/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BacklogDrainDto
 */
export interface BacklogDrainDto {
    /**
     * 
     * @type {number}
     * @memberof BacklogDrainDto
     */
    seededRunningRows?: number;
    /**
     * 
     * @type {number}
     * @memberof BacklogDrainDto
     */
    runningBefore?: number;
    /**
     * 
     * @type {number}
     * @memberof BacklogDrainDto
     */
    runningAfter?: number;
    /**
     * 
     * @type {number}
     * @memberof BacklogDrainDto
     */
    elapsedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof BacklogDrainDto
     */
    drainRowsPerSecond?: number;
}

/**
 * Check if a given object implements the BacklogDrainDto interface.
 */
export function instanceOfBacklogDrainDto(value: object): value is BacklogDrainDto {
    return true;
}

export function BacklogDrainDtoFromJSON(json: any): BacklogDrainDto {
    return BacklogDrainDtoFromJSONTyped(json, false);
}

export function BacklogDrainDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BacklogDrainDto {
    if (json == null) {
        return json;
    }
    return {
        
        'seededRunningRows': json['seededRunningRows'] == null ? undefined : json['seededRunningRows'],
        'runningBefore': json['runningBefore'] == null ? undefined : json['runningBefore'],
        'runningAfter': json['runningAfter'] == null ? undefined : json['runningAfter'],
        'elapsedMs': json['elapsedMs'] == null ? undefined : json['elapsedMs'],
        'drainRowsPerSecond': json['drainRowsPerSecond'] == null ? undefined : json['drainRowsPerSecond'],
    };
}

export function BacklogDrainDtoToJSON(json: any): BacklogDrainDto {
    return BacklogDrainDtoToJSONTyped(json, false);
}

export function BacklogDrainDtoToJSONTyped(value?: BacklogDrainDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seededRunningRows': value['seededRunningRows'],
        'runningBefore': value['runningBefore'],
        'runningAfter': value['runningAfter'],
        'elapsedMs': value['elapsedMs'],
        'drainRowsPerSecond': value['drainRowsPerSecond'],
    };
}

